import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaHome, FaCompass, FaExclamationTriangle } from 'react-icons/fa';
import './style.css';

const Error = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="error-404-page">
            {/* Arabic Background Pattern */}
            <div className="error-404-background" />

            <div className="error-404-container">
                <div className="error-404-content">

                    {/* Animated Icon */}
                    <div className="error-404-icon">
                        <div className="icon-circle">
                            <FaExclamationTriangle />
                        </div>
                    </div>

                    {/* 404 Number */}
                    <div className="error-404-number">
                        <h1>404</h1>
                    </div>

                    {/* Error Message */}
                    <div className="error-404-message">
                        <h2>{t('error404.pageNotFound')}</h2>
                        <p>{t('error404.pageNotFoundMessage')}</p>
                    </div>

                    {/* Action Buttons */}
                    <div className="error-404-actions">
                        <button
                            className="btn-404-primary"
                            onClick={() => navigate('/')}
                        >
                            <FaHome /> {t('error404.backToHome')}
                        </button>
                        <button
                            className="btn-404-secondary"
                            onClick={() => navigate(-1)}
                        >
                            <FaCompass /> {t('error404.goBack')}
                        </button>
                    </div>

                    {/* Helpful Links */}
                    <div className="error-404-links">
                        <p>{t('error404.youMightBeInterestedIn')}</p>
                        <div className="quick-links">
                            <a href="/login">{t('error404.login')}</a>
                            <a href="/signup">{t('error404.signUp')}</a>
                            <a href="/dashboard">{t('error404.dashboard')}</a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Error;